// src/pages/home/Home.styled.tsx
import styled from "styled-components";

export const HomeContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

export const HeroSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  padding: 7rem 1.5rem 2rem; /* Ajustado para incluir espaço para o footer */
  background: var(--color-background, #ffffff);
  color: var(--color-text-primary, #1f2937);
  text-align: center;
  justify-content: center; /* Para centralizar verticalmente o conteúdo */

  @media (min-width: 768px) {
    padding: 8rem 2rem 2rem; /* Ajustado para incluir espaço para o footer */
  }
`;

export const SloganText = styled.p`
  font-size: 1.5rem;
  font-weight: 500;
  color: var(--color-primary, #3b82f6);
  margin: 2rem 0;
  font-style: italic;
  max-width: 700px;

  @media (min-width: 768px) {
    font-size: 1.75rem;
  }
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1.5rem;
  width: 100%;
  max-width: 400px;

  @media (min-width: 576px) {
    flex-direction: row;
    justify-content: center;
  }
`;

export const FeaturedSection = styled.section`
  padding: 5rem 1.5rem;
  background: var(--color-surface, #f3f4f6);
`;

export const SectionTitle = styled.h2`
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 2.5rem;
  text-align: center;
  position: relative;

  &:after {
    content: "";
    display: block;
    width: 80px;
    height: 4px;
    background: var(--color-primary, #3b82f6);
    margin: 1rem auto 0;
    border-radius: 2px;
  }
`;

export const ProjectGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
  margin-top: 2rem;

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const ProjectCard = styled.div`
  background: var(--color-background, #ffffff);
  border-radius: 0.5rem;
  overflow: hidden;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  display: flex;
  flex-direction: column;
  height: 100%;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0px 8px 30px rgba(0, 0, 0, 0.12);
  }
`;

export const ProjectImage = styled.img`
  width: 100%;
  height: 200px;
  object-fit: cover;
`;

export const ProjectTitle = styled.h3`
  font-size: 1.25rem;
  font-weight: 600;
  margin: 1.25rem 1.25rem 0.5rem;
  color: var(--color-text-primary, #1f2937);
`;

export const ProjectDescription = styled.p`
  font-size: 1rem;
  color: var(--color-text-secondary, #6b7280);
  margin: 0 1.25rem 1rem;
  line-height: 1.6;
`;

export const TechTags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin: 0 1.25rem 1.25rem;
`;

export const TechTag = styled.span`
  font-size: 0.75rem;
  background: var(--color-surface, #f3f4f6);
  color: var(--color-text-secondary, #6b7280);
  padding: 0.25rem 0.75rem;
  border-radius: 999px;
  font-weight: 500;
`;

export const ButtonContainer = styled.div`
  padding: 1rem 1.5rem 1.5rem;
  display: flex;
  justify-content: flex-start;
  margin-top: auto;
`;

export const SkillsSection = styled.section`
  padding: 5rem 1.5rem;
  background: var(--color-background, #ffffff);
`;

export const SkillsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
  max-width: 800px;
  margin: 0 auto;

  @media (min-width: 640px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const SkillName = styled.h3`
  font-size: 1.125rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
`;

export const SkillBar = styled.div`
  width: 100%;
  height: 8px;
  background: var(--color-surface, #f3f4f6);
  border-radius: 4px;
  overflow: hidden;
`;

export const SkillLevel = styled.div<{ width: number }>`
  height: 100%;
  background: var(--color-primary, #3b82f6);
  border-radius: 4px;
  width: ${props => props.width}%;
  transition: width 1s ease-in-out;
`;
